import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  \n  color: ",
        ";\n  &:hover:not(:disabled){\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  background: transparent;\n  border: 2px solid transparent;\n  border-radius: 10px;\n  font-weight: ",
        ";\n  color: ",
        ";\n  &:hover:not(:disabled){\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Button from "../Button/Button";
import { variants } from "../Button/types";
var ActiveButton = styled(Button).withConfig({
    componentId: "sc-513a2b3c-0"
})(_templateObject(), function(param) {
    var theme = param.theme, variant = param.variant;
    return variant === variants.PRIMARY ? "#FFFFFF" : variant === variants.SECONDARY ? theme.colors.textSubtle : "#FFFFFF";
}, function(param) {
    var theme = param.theme;
    return theme.colors.tertiary;
});
var InactiveButton = styled(Button).withConfig({
    componentId: "sc-513a2b3c-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, variant = param.variant;
    return variant === variants.SECONDARY ? "600" : "400";
}, function(param) {
    var theme = param.theme, variant = param.variant;
    return variant === variants.PRIMARY ? theme.colors.textSubtle : variant === variants.SECONDARY ? theme.colors.textSubtle : theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.tertiary;
});
var ButtonMenuItem = function(_param) {
    var _isActive = _param.isActive, isActive = _isActive === void 0 ? false : _isActive, _variant = _param.variant, variant = _variant === void 0 ? variants.PRIMARY : _variant, as = _param.as, props = _object_without_properties(_param, [
        "isActive",
        "variant",
        "as"
    ]);
    if (!isActive) {
        return /*#__PURE__*/ _jsx(InactiveButton, _object_spread({
            forwardedAs: as,
            variant: variant
        }, props));
    }
    return /*#__PURE__*/ _jsx(ActiveButton, _object_spread({
        forwardedAs: as,
        variant: variant
    }, props));
// return <Button as={as} variant={variant} {...props} />;
};
export default ButtonMenuItem;
